var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      ref: "collapse",
      staticClass: "collapse",
      style: {
        height: _vm.containerH + "px",
        "padding-right": (_vm.hideControl ? 0 : 60) + "px",
      },
    },
    [
      _c(
        "div",
        { ref: "content", staticClass: "collapse-content" },
        [_vm._t("default")],
        2
      ),
      !_vm.hideControl
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.controlVisible,
                  expression: "controlVisible",
                },
              ],
              staticClass: "collapse-control",
              style: { fontSize: _vm.textFontSize },
              on: { click: _vm.handleControl },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.isShow ? _vm.foldText : _vm.unfoldText) + " "
              ),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.hideControlIcon,
                    expression: "!hideControlIcon",
                  },
                ],
                staticClass: "collapse-control-icon",
                class: _vm.isShow ? "el-icon-arrow-up" : "el-icon-arrow-down",
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }